<template>
  <div>
    <v-card v-if="headers && headers.length > 0">
      <v-card-title class="mx-auto text-center" :style="getThemeStyle">
        {{ "Create " + formatTableName(selTable) }}
      </v-card-title>

      <v-row>
        <v-col
          :cols="12"
          v-for="({ value }, hief) in headers"
          :key="hief + Math.random()"
          class="mx-2"
        >
          <v-datetime-picker
            v-if="value == 'date_time'"
            :label="value.toUpperCase() + ' [' + entryEditData[value] + ']'"
            prepend-icon="mdi-calendar"
            v-model="entryEditData[value]"
            @input="formatDateTime"
          ></v-datetime-picker>

          <div
            v-else-if="value == 'date' || value == 'start' || value == 'end'"
          >
            <v-menu
              v-model="dateMenu[value]"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="entryEditData[value]"
                  :label="value.toUpperCase()"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :id="value"
                v-model="entryEditData[value]"
                @input="dateMenu[value] = false"
                :value="entryEditData[value]"
                full-width
                :rules="[rules.required]"
                :landscape="$vuetify.breakpoint.smAndUp"
                class="mt-4"
                :label="('' + value) | catifyHead"
                @change="getSelectedValue(value)"
              ></v-date-picker>
            </v-menu>
          </div>

          <div v-else-if="value == 'color'">
            <span>{{ ("" + value) | catifyHead }}</span
            ><input
              type="color"
              :rules="[rules.required]"
              flat
              @change="getColorValue(value)"
              :id="value"
            />
          </div>

          <ForeignKeyField
            v-else-if="
              foreignKeysArray &&
              foreignKeysArray.length > 0 &&
              foreignKeysArray.includes(value)
            "
            :foreignColumn="value"
            :foreignTablesArray="foreignTablesArray"
            :foreignKeysArray="foreignKeysArray"
            :foreignFieldValue="entryEditData[value]"
            :branchID="null"
            @field-selected="
              (catArr) => {
                entryEditData[value] = catArr[0];
                getSelectedValue(value);
              }
            "
          ></ForeignKeyField>

          <v-textarea
            v-else-if="value != 'selection'"
            :rules="[rules.required]"
            :id="value"
            rows="1"
            :label="('' + value) | catifyHead"
            :placeholder="value | catifyHead"
            :value="entryEditData[value]"
            @focusout="getValue(value)"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-card-actions class="mx-10">
        <v-btn
          class="mb-6"
          dark
          rounded
          :color="btnColor"
          @click="saveFormData()"
          >{{ btnText }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import crudJs from "./crud.js";
import moment from "moment-timezone";
import ForeignKeyField from "@/components/General/ForeignKeyField.vue";

export default {
  props: ["selTable", "tblHeaders", "foreignTablesArray", "foreignKeysArray"],
  components: { ForeignKeyField },
  watch: {
    tblHeaders(newVal) {
      this.headers = newVal;
    },
  },
  mounted() {
    this.headers = this.tblHeaders;
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
  },
  data() {
    return {
      headers: [],
      entryEditData: {},
      dateTime: null,
      dateMenu: [],
      myFormData: {},
      selectData: {},
      ddObj: { id: "" },
      btnText: "Save Data",
      btnColor: "#3dc7be",
      images: {},
      formStatus: null,
      fileLabel: "Select File to Upload",

      date: new Date().toISOString().substring(0, 10),
      rules: {
        email: (v) => (v || "").match(/@/) || "Please enter a valid email",
        length: (len) => (v) =>
          (v || "").length >= len ||
          `Invalid character length, required ${len}`,

        required: (v) => !!v || "This field is required",
      },
    };
  },
  methods: {
    formatTableName(table) {
      return crudJs.formatTableName(table);
    },

    formatDateTime(dateTime) {
      const dt = moment.tz(dateTime, "Africa/Johannesburg");
      this.dateTime = dt.format("YYYY-MM-DD HH:mm:ss");
      if (this.status == "edit") {
        this.saveChanges("lesson_date_time");
      }
    },
    getSelectedValue() {
      //console.log(this.entryEditData);
    },
    getValue(column) {
      if (column != "selection") {
        this.entryEditData[column] = event.target.value;
      }
    },
    getColorValue(column) {
      this.entryEditData[column] = document.getElementById(column).value;
      if (this.status == "edit") {
        this.saveChanges(column);
      }
    },
    setSelectValue(column) {
      this.selectData[column] = this.ddObj;
    },
    setBase64Img(column) {
      const file = event.target.files[0];
      const fileReader = new FileReader();

      fileReader.addEventListener("load", () => {
        this.entryEditData[column] = fileReader.result;
        if (this.status == "edit") {
          this.saveChanges(column);
        }
        this.fileLabel = this.catifyHead(column) + " IS READY!";
      });

      fileReader.readAsDataURL(file);
    },

    setSiteColors(colorObj) {
      this.$store.commit("setThemeColor", colorObj.primary_bg_color);
      this.$store.commit("setSecondaryColor", colorObj.secondary_bg_color);

      // this.$store.commit("setCurrentUser", data.user);

      localStorage.setItem("themeColor", colorObj.primary_bg_color);
      localStorage.setItem("secondaryColor", colorObj.secondary_bg_color);

      // this.$router.push({ name: "switchboard" });
    },
    saveFormData() {
      this.$store.commit("setLoader", true);

      const keys = Object.keys(this.entryEditData);
      keys.forEach((k) => {
        if (k.includes("date_time")) {
          const dateTime = moment.tz(this.dateTime, "Africa/Johannesburg");
          this.entryEditData[k] = dateTime.format("YYYY-MM-DD HH:mm:ss");
        }
      });

      axios
        .postDataWithToken(
          "/auth/save-form-data",
          {
            table: this.selTable,
            data: this.entryEditData,
          },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          if (response == "success") {
            this.$emit("data-saved");
            this.$toast.success("Data Saved Successfully!", { duration: 3000 });
          }
        });
    },
  },

  filters: {
    catifyHead(value) {
      return crudJs.formatTableName(value);
    },
  },
};
</script>

<style></style>
